module.exports = __webpack_public_path__ + "static/img/fuwu.0cac94c3.png";